import { render, staticRenderFns } from "./LogoNav.vue?vue&type=template&id=3015b936&"
import script from "./LogoNav.vue?vue&type=script&lang=js&"
export * from "./LogoNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LogoNav.vue"
export default component.exports